import { formatCSV } from './format-csv.js';
import { downloadCSV } from '../../../core/utils/download.js';
import { CSS_DOWNLOAD_FILENAME } from '../../core/constants.js';
import type { XYChartSeriesWithDatapoints } from '../types/xy-chart-internals.js';

/**
 * XYChart data and downloads the file.
 * @param data - XYChart series with data points
 * @returns void
 */
export const buildAndDownloadCsv = (data: XYChartSeriesWithDatapoints[]) => {
  const csvString = formatCSV(data);
  downloadCSV(csvString, CSS_DOWNLOAD_FILENAME);
};
